import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

export const useRecaptcha = () => {
  const { executeRecaptcha } = useGoogleReCaptcha();

  const refetchRecaptcha = async () => {
    try {
      if (!executeRecaptcha) {
        console.log('Execute recaptcha not yet available');
        return null;
      }
      return await executeRecaptcha('login_account_form');
    } catch (error) {
      console.error('refetchRecaptcha error', error);
      return null;
    }
  };

  return { refetchRecaptcha, executeRecaptcha };
};